import React, {FC} from 'react';

/** 환불 정책 한국어 본문(구조 1:1 대응 content/zh.tsx, 클래스명은 TermsOfUse__* BEM 재사용). 2026-09-17 AI 번역, 법률 문구는 비즈니스 검토 대기 */
const KoContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">시행일: August 28, 2026</p>
      <p className="v3-doc-meta">최종 업데이트: August 28, 2026</p>
      <p>Xiangji가 제공하는 제품 및 서비스를 이용해 주셔서 감사합니다.</p>
      <p>
        본 Xiangji 환불 정책(이하 “본 정책”)은 귀하가 구매하는 Xiangji의 구독 서비스, 요금제, 크레딧 및 기타 유료
        서비스에 적용됩니다.
      </p>
      <p>
        Xiangji는 사용자에게 명확하고 투명한 환불 규정을 제공하기 위해 노력하고 있습니다. 관련 서비스를 구매하기 전에 본
        정책을 주의 깊게 읽고 충분히 이해해 주시기 바라며, 특히 환불 대상 여부, 환불 범위, 환불 제외 사항 및 구독 해지와
        관련된 조항에 유의해 주십시오.
      </p>
      <p>구매하시는 특정 Xiangji 서비스에 고유한 환불 규정이 별도로 있는 경우, 해당 전용 규정이 우선 적용됩니다.</p>
      <section>
        <h2>1. 환불 대상 범위</h2>
        <h3>SaaS 구독 서비스</h3>
        <p>
          Xiangji가 제공하는 일부 SaaS 구독 서비스에 대해 Xiangji는 <strong>최초 구매에 대한 30일 환불 보장</strong>을
          제공합니다.
        </p>
        <p>
          환불 조건을 충족하는 사용자는 해당 구독 서비스를 최초로 구매한 날로부터 달력상 30일 이내에 Xiangji에 환불을
          신청할 수 있습니다.
        </p>
        <h3>최초 구매의 판정</h3>
        <p>
          별도의 규정이 없는 한, “최초 구매”란 동일한 Xiangji 계정으로 해당 SaaS 구독 서비스를 처음 구매하는 것을
          의미합니다.
        </p>
        <p>
          <strong>
            동일한 사용자가 서로 다른 계정으로 반복하여 가입 및 구매하거나, 기타 방법으로 최초 구매 제한을 회피하는
            경우, 해당 구매는 새로운 최초 구매로 인정되지 않습니다.
          </strong>
        </p>
        <p>
          Xiangji는 계정, 결제 정보, 기기 정보, 주문 기록 및 기타 합리적인 정보를 바탕으로 해당 구매가 최초 구매에
          해당하는지 여부를 판정할 권리를 가집니다.
        </p>
        <h3>기타 유료 서비스</h3>
        <p>
          30일 환불 보장 대상으로 명시적으로 표시된 서비스를 제외하고, 기타 유료 서비스의 환불 지원 여부는 해당 구매
          페이지, 주문 페이지, 전용 서비스 약관 또는 관련 규정에 따릅니다.
        </p>
      </section>
      <section>
        <h2>2. 환불 조건</h2>
        <p>다음 조건을 모두 충족하는 경우 환불을 신청할 수 있습니다:</p>
        <ol>
          <li>환불 대상에 해당하는 최초 구매 사용자인 경우;</li>
          <li>해당 서비스를 최초로 구매한 날로부터 달력상 30일 이내에 환불 신청을 제출한 경우;</li>
          <li>주문이 정당하고 유효하며, 사기, 악의적 구매 또는 기타 비정상적인 행위가 없는 경우;</li>
          <li>Xiangji 이용약관 또는 기타 관련 서비스 규정을 위반하지 않은 경우;</li>
          <li>해당 서비스 페이지에 게시된 기타 환불 조건을 충족하는 경우;</li>
        </ol>
        <p>
          <strong>
            환불 대상에 해당한다는 것이 구매한 모든 서비스, 크레딧 또는 기타 혜택이 무조건 환불될 수 있음을 의미하지는
            않습니다. 실제 환불 금액과 환불 범위는 본 정책 및 해당 서비스 규정에 따릅니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>3. 환불 금액 및 이미 사용한 서비스</h2>
        <h3>구독 서비스</h3>
        <p>
          30일 환불 보장 대상에 해당하는 구독 서비스의 경우, Xiangji는 원칙적으로 환불 조건을 충족하는 주문에 대해
          귀하가 실제로 지불한 금액을 환불합니다.
        </p>
        <h3>이미 사용한 크레딧</h3>
        <p>
          구독 서비스에 크레딧, AI 생성 크레딧, 이미지 번역 크레딧, API 호출 크레딧 또는 기타 수량화 가능한 서비스
          혜택이 포함되어 있는 경우,
          <strong>
            Xiangji는 환불 신청 전에 귀하가 실제로 사용한 서비스량에 따라 환불 금액에서 상응하는 금액을 공제할 수
            있습니다.
          </strong>
        </p>
        <p>구체적인 공제 방법은 관련 서비스 페이지 또는 구매 규정에 따릅니다.</p>
        <h3>소진된 서비스</h3>
        <p>실제로 사용되거나 소진되었거나 전달되어 복구할 수 없는 서비스의 예는 다음과 같습니다:</p>
        <ul>
          <li>완료된 이미지 번역;</li>
          <li>이미 생성된 AI 이미지;</li>
          <li>이미 사용한 이미지 편집 또는 생성 서비스;</li>
          <li>이미 사용한 동영상 처리 서비스;</li>
          <li>완료된 상품 상세 페이지 또는 마케팅 소재 생성;</li>
          <li>이미 수행된 API 호출;</li>
          <li>기타 실제로 소진된 서비스;</li>
        </ul>
        <p>
          Xiangji는 실제 사용량을 기준으로 환불 시 상응하는 요금을 공제하거나 소진된 부분을 환불하지 않을 권리를
          가집니다.
        </p>
        <h3>제3자 비용</h3>
        <p>
          <strong>
            관련 서비스에 제3자 플랫폼, AI 모델, 결제 기관, 클라우드 서비스 제공업체 또는 기타 제3자에게 발생한 비용이
            포함되어 있고, 해당 비용이 실제로 발생하여 환불이 불가능한 경우, Xiangji는 환불 금액에서 상응하는 비용을
            공제할 권리를 가집니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>4. 환불이 적용되지 않는 경우</h2>
        <p>다음의 경우에는 원칙적으로 환불을 제공하지 않습니다:</p>
        <ol>
          <li>최초 구매 후 달력상 30일이 경과한 후에 제출된 환불 신청;</li>
          <li>업그레이드, 갱신, 재구매 또는 기타 반복 구매를 포함한 최초 구매가 아닌 구매;</li>
          <li>“환불 불가”로 명시적으로 표시된 특정 서비스 또는 제품;</li>
          <li>이미 사용되었거나 소진된 크레딧 또는 서비스;</li>
          <li>Xiangji가 회수할 수 없는 제3자 서비스에서 발생한 비용;</li>
          <li>잘못된 요금제, 계정, 수량 또는 서비스를 구매하는 등 귀하 본인의 사유로 인한 구매 착오;</li>
          <li>Xiangji 이용약관 또는 기타 관련 규정을 위반한 경우;</li>
          <li>악의적인 가입, 대량 가입, 비정상 구매, 크레딧 파밍, 환불 정책 남용 또는 이와 유사한 행위;</li>
          <li>사기, 가짜 거래, 무단 카드 결제 또는 기타 비정상적인 결제 행위;</li>
          <li>법령에 따라 환불이 금지되거나 해당 서비스의 성격상 환불이 부적절한 기타 경우.</li>
        </ol>
        <p>
          <strong>
            Xiangji는 사용자가 악의적인 환불, 반복적인 환불 또는 기타 환불 정책 남용 행위를 하였다고 판단할 합리적인
            근거가 있는 경우, 해당 환불 신청을 거절하고 이용약관에 따라 상응하는 조치를 취할 권리를 가집니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>5. 구독 해지 및 자동 갱신</h2>
        <h3>구독 해지</h3>
        <p>
          Xiangji 구독 서비스를 계속 이용하지 않으려는 경우, 제품 페이지에서 제공하는 방법을 통해 구독을 해지할 수
          있습니다.
        </p>
        <p>
          <strong>구독을 해지하더라도 자동으로 환불되지 않습니다.</strong>
        </p>
        <p>
          이미 현재 구독 기간에 대해 결제를 완료한 경우, 해지는 통상 이후 자동 갱신을 끄는 것을 의미하며, 해당 서비스
          규정에 별도의 정함이 없는 한 현재 결제된 서비스 기간 내에서 해당 서비스를 계속 이용할 수 있습니다.
        </p>
        <h3>자동 갱신</h3>
        <p>
          자동 갱신을 지원하는 구독 서비스의 경우, 구독 페이지 또는 계정 설정의 관련 방법에 따라 자동 갱신을 해제할 수
          있습니다.
        </p>
        <p>자동 갱신을 해제한 후에도 이미 결제된 현재 구독 기간이 그 결과로 자동 환불되는 경우는 통상 없습니다.</p>
        <h3>갱신 주문</h3>
        <p>
          <strong>
            법령에 별도의 규정이 있거나 해당 서비스 페이지에 명시적으로 안내된 경우를 제외하고, 구독 갱신, 자동 갱신 및
            업그레이드로 발생한 주문은 30일 최초 구매 환불 보장의 대상이 아닙니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>6. 환불 신청 절차</h2>
        <p>환불 조건을 충족하는 경우, 다음 채널을 통해 Xiangji에 환불을 신청할 수 있습니다:</p>
        <p>
          <strong>고객센터 이메일: </strong>
          <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
        </p>
        <p>
          <strong>문의 전화: </strong>+86 176 6407 5341
        </p>
        <p>환불 신청 시 아래 사항을 최대한 많이 제공해 주시기 바랍니다:</p>
        <ul>
          <li>Xiangji 계정;</li>
          <li>주문 번호;</li>
          <li>구매 시각;</li>
          <li>구매한 제품 또는 구독 요금제;</li>
          <li>환불 사유;</li>
          <li>주문과 관련된 기타 필요한 정보.</li>
        </ul>
        <p>주문 확인 및 계정 보안 보호를 위해 Xiangji는 필요한 주문 및 본인 확인 정보를 요청할 수 있습니다.</p>
      </section>
      <section>
        <h2>7. 환불 심사 및 정산</h2>
        <h3>심사 기간</h3>
        <p>
          Xiangji는 완전한 환불 신청을 접수한 후 요청을 심사하며, 통상 <strong>3영업일</strong> 이내에 심사 결과를
          안내합니다.
        </p>
        <p>
          환불 신청이 복잡한 주문, 비정상 거래, 제3자 결제 기관 또는 기타 추가 확인이 필요한 상황과 관련된 경우, 심사
          기간이 그에 따라 연장될 수 있습니다.
        </p>
        <h3>환불 방법</h3>
        <p>
          <strong>
            원칙적으로 환불은 원래 결제 수단을 통해, 주문 결제 시 귀하가 실제로 사용한 결제 계정 또는 결제 수단으로
            반환됩니다.
          </strong>
        </p>
        <p>
          결제 기관, 은행, 계정 상태 또는 기타 객관적인 사유로 인해 원래 결제 수단을 통한 환불이 불가능한 경우,
          Xiangji는 귀하와 협의하여 기타 합리적인 환불 방법을 모색합니다.
        </p>
        <h3>정산 기간</h3>
        <p>
          Xiangji의 환불 승인 후 실제 입금 시점은 관련 결제 기관, 은행 및 기타 금융 서비스 기관의 처리 시간에 따라
          달라집니다.
        </p>
        <p>
          <strong>Xiangji는 환불이 특정 영업일 수 이내에 입금될 것을 보장할 수 없습니다.</strong>
        </p>
        <p>
          환불이 완료 처리되었음에도 합리적인 기간 내에 자금을 받지 못한 경우, Xiangji 고객센터에 즉시 문의해 주시면
          환불 상태 확인을 도와드리겠습니다.
        </p>
      </section>
      <section>
        <h2>8. 환불 후 서비스 조정</h2>
        <p>
          환불이 완료된 후, Xiangji는 환불 대상 서비스의 유형에 따라 귀하의 계정 및 관련 혜택에 상응하는 조정을 할
          권리를 가지며, 여기에는 다음이 포함되나 이에 국한되지 않습니다:
        </p>
        <ul>
          <li>관련 구독 서비스를 취소하거나 종료하는 것;</li>
          <li>환불된 주문과 관련된 미사용 크레딧을 공제하거나 삭제하는 것;</li>
          <li>관련 멤버십 혜택을 취소하는 것;</li>
          <li>미사용 크레딧 또는 서비스 횟수를 회수하는 것;</li>
          <li>환불된 서비스의 계속 사용을 제한하는 것.</li>
        </ul>
        <p>
          <strong>
            환불 완료 후 해당 주문에 상응하는 서비스 혜택이 계속 사용되는 경우, Xiangji는 실제 사용량을 기준으로 관련
            요금을 재산정하거나 기타 합리적인 조치를 취할 권리를 가집니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>9. 특수 결제 및 제3자 플랫폼</h2>
        <p>
          Apple, Google, PayPal, Stripe 또는 기타 제3자 결제 플랫폼을 통해 Xiangji 서비스를 구매한 경우, 환불은 해당
          결제 플랫폼의 규정에 따라 처리되어야 할 수 있습니다.
        </p>
        <p>
          <strong>
            제3자 플랫폼이 환불 신청, 환불 시점 또는 환불 방법에 대해 특별한 규정을 두고 있는 경우, 해당 플랫폼의 절차에
            따라 신청을 제출해야 할 수 있습니다.
          </strong>
        </p>
        <p>
          제3자 결제 플랫폼 자체에서 발생하는 수수료, 환율 차이, 결제 실패, 환불 지연 또는 기타 문제에 대하여, Xiangji는
          합리적인 범위 내에서 처리를 지원하지만, Xiangji가 통제할 수 없는 범위의 손실에 대해서는 책임을 지지 않습니다.
        </p>
      </section>
      <section>
        <h2>10. 환불 정책의 변경</h2>
        <p>
          <strong>
            Xiangji는 법령의 변경, 사업 조정, 결제 방식의 변경 및 실제 운영 상황에 대응하여 본 환불 정책을 수정할 권리를
            가집니다.
          </strong>
        </p>
        <p>
          환불 정책에 중대한 변경이 있는 경우, Xiangji는 웹사이트 공지, 제품 페이지, 팝업, 사이트 내 알림 또는 기타
          합리적인 방법을 통해 귀하에게 통지합니다.
        </p>
        <p>
          <strong>
            이미 구매하였고 유효 기간이 남아 있는 서비스의 경우, 환불 권리와 관련된 사항은 법령에 별도의 규정이 있거나
            당사자 간 별도의 합의가 있는 경우를 제외하고, 원칙적으로 구매 시점에 적용되는 환불 정책에 따릅니다.
          </strong>
        </p>
        <p>수정된 환불 정책은 게시일 또는 지정된 시행일부터 효력이 발생합니다.</p>
      </section>
      <section>
        <h2>11. 문의하기</h2>
        <p>
          환불 정책, 환불 대상, 환불 금액 또는 환불 절차에 대해 궁금한 점이 있는 경우, 다음 채널을 통해 문의하실 수
          있습니다:
        </p>
        <ul>
          <li>
            <strong>고객센터 이메일: </strong>
            <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
          </li>
          <li>
            <strong>문의 전화: </strong>+86 176 6407 5341
          </li>
          <li>
            <strong>공식 웹사이트: </strong>
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
        </ul>
        <p>환불 신청 또는 문의를 접수한 후 합리적인 기간 내에 처리하겠습니다.</p>
        <p>
          <strong>특별 안내: </strong>
        </p>
        <p>
          환불 정책은 관련 법령에 따라 귀하가 가지는 기타 법정 권리에 영향을 미치지 않습니다. 본 정책이 관련 법령과
          충돌하는 경우, 법령의 강행 규정이 우선 적용됩니다.
        </p>
      </section>
    </>
  );
};

export default KoContent;
